module.exports = __webpack_public_path__ + "img/52e67cc.png";